<template>
    <div class='lcgl'>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="名称" prop='gsjgId'>
                    <el-select v-model="searchForm.gsjgId" placeholder="请选择" :filterable='true'>
                        <el-option
                        v-for="item in gsjgOptions"
                        :key="item.id"
                        :label="item.jgmc"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
     
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
            <el-button type="primary" @click="del()" :disabled="multipleSelection.length==0">删除</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            @selection-change="handleSelectionChange"

        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="gsjgmc" label="归属机构名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pbbf" label="评标办法名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="zt" label="状态"  width="80" :formatter="ztFormatter"></el-table-column>
            <el-table-column prop="lrsj" label="录入时间" width="170" >
            </el-table-column>
            <el-table-column  label="操作" width="140" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='look(scope.row)'>查看</el-button>
                    <el-button type="text"  @click='enableOrdisable(scope.row,1)' v-if='scope.row.zt==0'>启用</el-button>
                    <el-button type="text"  @click='enableOrdisable(scope.row,0)' v-else>停用</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog :title='isLook?"查看流程":"新建流程"' :visible.sync="dialogVisible" width='900px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="120px" :rules="formRules" :disabled="isLook">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="归属机构" prop='gsjgId' :filterable='true'>
                            <el-input v-model='form.gsjgmc' v-if='isLook'></el-input>
                            <el-select v-model="form.gsjgId" placeholder="请选择" @change='getPbbf(form.gsjgId)' v-else>
                                <el-option
                                v-for="item in gsjgOptions"
                                :key="item.id"
                                :label="item.jgmc"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="12">
                         <el-form-item label="状态" prop='zt'>
                             <el-radio-group v-model="form.zt">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="0">停用</el-radio>
                             </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
               <el-form-item label="评标办法" prop='pbbfId' :filterable='true'>
                   <el-input v-model='form.pbbf' v-if='isLook'></el-input>
                    <el-select v-model="form.pbbfId" placeholder="请选择" v-else style="width:100%">
                        <el-option
                        v-for="item in pbbfOptions"
                        :key="item.id"
                        :label="item.pbbfmc"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='流程子节点' prop='lcIds'>
                    <el-transfer
                        v-model="form.lcIds"
                        :props="{
                            key: 'id',
                            label: 'mc'
                        }"
                        target-order='push'
                        @change="handleChange"
                        @right-check-change='rightChange'
                        :data="lczjdData">
                        <el-button type="primary" slot="right-footer" size="small" @click='upLc' :disabled="upOrDown">上移</el-button>
                        <el-button type="primary" slot="right-footer" size="small" @click='downLc' :disabled="upOrDown">下移</el-button>
                    </el-transfer>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")' v-if='!isLook'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")' v-if='!isLook'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                gsjgId:'',
            },
            gsjgOptions:[],
            tableData:[],
            lczjdData:[],
            pbbfOptions:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            isLook:false,
            form:{
            },
            formRules:{
                gsjgId:[{required:true,trigger:'change',message:'必填项'}],
                pbbfId:[{required:true,trigger:'change',message:'必填项'}],
            },
            upOrDown:true,
            upOrDownId:''
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getLcgl(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list;
                    this.total=res.data.data.total;
                    this.gsjgOptions=res.data.data.gsjgList;
                    this.lczjdData=res.data.data.lcdyList
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //新增
        add(){
            this.form={
                gsjgId:'',
                pbbfId:'',
                zt:1,
                lcIds:[]
            }
            this.dialogVisible=true;
            this.isLook=false;
            this.$nextTick(()=>{
                this.$refs['form'].clearValidate();
            })
        },
        getPbbf(id){
            let para={
                gsjgId:id,
                lx:this.adminLx
            }
            this.$api.getPbbf(para).then(res=>{
                if(res.data.meta.success){
                   this.pbbfOptions=res.data.data.gsjg
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        upLc(){
            let arr=Object.assign([],this.form.lcIds);
            let index=arr.findIndex(item=>{
                return item==this.upOrDownId
            })
            if(index==0){
                this.$message('已经第一位了')
            }else{
                arr[index] = arr.splice(index-1, 1, arr[index])[0];
                this.$set(this.form,'lcIds',arr)
            }
            
        },
        downLc(){
            let arr=this.form.lcIds
            let index=arr.findIndex(item=>{
                return item==this.upOrDownId
            })
            if(index!=arr.length-1){
                arr[index] = arr.splice(index+1, 1, arr[index])[0];
                this.$set(this.form,'lcIds',arr)
            }else{
                this.$message('已经最后一位了')
            }
            
        },
        rightChange(a,b){
            if(a.length==1){
                this.upOrDown=false;
            }else{
                this.upOrDown=true;
            }
            this.upOrDownId=a[0]
        },
        //查看
        look(row){
            this.dialogVisible=true;
            this.isLook=true;
            this.form=Object.assign({},row)
        },
        saveForm(formName){
            if(this.isLook){
                this.dialogVisible=false;
            }else{
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        let para=this.form;
                        para.lx=this.adminLx
                        this.$api.saveLcgl(para).then(res=>{
                            if(res.data.meta.success){
                                this.$message({
                                    type:'success',
                                    message:'保存成功！'
                                })
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.data.meta.message
                                })
                            }
                        }).catch(()=>{})
                    }else{
                        return false;
                    }
                })
            }
            
        },
        //重置
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //删除
        del(row){
            let text=''
            let para={
                lx:this.adminLx
            }
            if(row){
                text='确定要删除当前的流程吗？'
                para.id=row.id
            }else{
                text='确定要删除选中的流程吗？';
                let ids=''
                this.multipleSelection.forEach(item=>{
                    ids+=item.id+','
                })
                para.id=ids.slice(0,ids.length-1)
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delLcgl(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'删除成功！'
                        })
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });
        },
        enableOrdisable(row,lx){
            let text=''
            if(lx==1){
                text='确定要启用选中的流程吗？';
            }else{
                text='确定要停用选中的流程吗？';
            }
            this.$confirm('确定要'+lx==1?'启用':'停用'+'选中的流程吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let para={
                    id:row.id,
                    lx:this.adminLx,
                    zt:lx
                }
                this.$api.enableOrdisableLcgl(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'保存成功！'
                        })
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });

        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        ztFormatter(row,col,column,index){
            return row.zt==0?'停用':'启用'
        },
        handleChange(){

        }
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less">
.lcgl{
.el-transfer-panel{
    width: 40%;
}
.el-transfer__buttons{
    width: 20%;
    button.el-button{
        width:40px;
        min-width: 40px;
        display: block;
        margin: 10px auto;
    }
}
}
</style>